import { AccountMenu } from '@components/App/AccountMenu'
import { Toolbar } from '@components/App/Toolbar'
import { CollaborationViewers } from '@components/ArtBoard/Collaboration'
import { useHeaderToolbar } from '@components/ArtBoard/Header/components/HeaderControls/useHeaderToolbar'
import type React from 'react'

import {
  ExportFromSeo,
  GaConnect,
  SaveProject,
  Settings,
  ShareAndPublish,
  StructureButton,
  Template,
} from './components'
import css from './styles.module.css'

export const HeaderControls: React.FC = () => {
  const {
    showSaveProject,
    isDisabled,
    isPrinting,
    isReadOnly,
    seoMode,
    isTemplate,
  } = useHeaderToolbar()

  if (isPrinting) {
    return null
  }

  return (
    <Toolbar extraClassName={css.header_controls}>
      <CollaborationViewers />
      {!isDisabled && seoMode && <GaConnect />}
      {!isDisabled && seoMode && !isReadOnly && <ExportFromSeo />}

      {!isDisabled && showSaveProject && <SaveProject />}

      {!isDisabled && <ShareAndPublish />}

      <StructureButton />

      {!isDisabled && !seoMode && <Settings />}

      {!seoMode && isTemplate && <Template />}

      <AccountMenu />
    </Toolbar>
  )
}
